module.exports = __webpack_public_path__ + "img/swiper2-4.7eafbcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/findUs/swiper2-4.jpg
// module id = 356
// module chunks = 0